// extracted by mini-css-extract-plugin
export default {"panel":"c1a7c6110002","productsWrap":"e9264adbf898","messageWrap":"bd6d9379243e","footer":"a606accee02a","footerLink":"b5e1f766f9aa"};